import { Box } from '@chakra-ui/react';
import { FaceliftLoadingIndicator } from '@/components/Atoms/FaceliftLoadingIndicator';
import { FaceliftPdfViewer } from '@/components/Atoms/FaceliftPdfViewer';
import FaceliftText from '@/components/Atoms/FaceliftText/FaceliftText';

interface FaceliftPdfViewerContainerProps {
  isLoading: boolean;
  url?: string;
  /** Shown when the invoice has no content or the document is unavailable (e.g. empty PDF) */
  isEmptyOrUnavailable?: boolean;
  /** Shown when the PDF request failed (network/API error) */
  isLoadError?: boolean;
}

export const FaceliftPdfViewerContainer: React.FC<
  FaceliftPdfViewerContainerProps
> = ({ isLoading, url, isEmptyOrUnavailable, isLoadError }) => {
  const showEmptyMessage = !isLoading && isEmptyOrUnavailable;
  const showErrorMessage = !isLoading && isLoadError && !isEmptyOrUnavailable;
  const showGenericNoPdf = !isLoading && !url && !isEmptyOrUnavailable && !isLoadError;

  return (
    <Box
      height="600px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      maxHeight={'80vh'}
      px={4}
    >
      {isLoading ? (
        <FaceliftLoadingIndicator />
      ) : url ? (
        <FaceliftPdfViewer url={url} />
      ) : showEmptyMessage ? (
        <FaceliftText
          color={{ base: 'gray.600', _dark: 'gray.400' }}
          textAlign="center"
          fontSize="md"
        >
          This invoice has no content or the document is unavailable.
        </FaceliftText>
      ) : showErrorMessage ? (
        <FaceliftText color="red.500" textAlign="center" fontSize="md">
          Unable to load this invoice. Please try again.
        </FaceliftText>
      ) : showGenericNoPdf ? (
        <FaceliftText color="red.500" textAlign="center" fontSize="md">
          Failed to load invoice PDF. Please try again.
        </FaceliftText>
      ) : null}
    </Box>
  );
};
